export const extractParts = (value: string): [string, string, string] => {
    const hasNumber = /\d/.test(value)

    if (!hasNumber) {
        return [value, '', '']
    }

    const match = value.match(/^([A-Za-z]*)(\d+)([A-Za-z]*)$/)

    if (!match) {
        return ['', '', '']
    }

    return [match[1], match[2], match[3]]
}

export const compareValueWithPrefix = (
    [aPrefix, aNum, aSuffix = '']: [string, string, string?],
    [bPrefix, bNum, bSuffix = '']: [string, string, string?]
): number => {
    if (aPrefix && !bPrefix) {
        return 1
    }

    if (!aPrefix && bPrefix) {
        return -1
    }

    if (aPrefix !== bPrefix) {
        return aPrefix.localeCompare(bPrefix)
    }

    const numComparison = Number(aNum) - Number(bNum)

    if (numComparison !== 0) {
        return numComparison
    }

    return aSuffix.localeCompare(bSuffix)
}
